<tt-side-drawer-container *ngIf="!('mobile' | mediaQuery)">
    <tt-side-drawer #drawer="sideDrawer" ttInitialState="open" ttMode="side" ttWidth="28rem">
        <div class="sp-5 flex-column height-full">
            <span matTooltip="Skjul sidebar" class="fal fa-chevron-square-left tt-drawer-button tt-drawer-button--close" (click)="drawer.close()"></span>
            <tt-input ttLabel="search" [(ttModel)]="filter" ttShowClearButton></tt-input>
            <tt-button-goto ttText="docarticleedit_create_new_book" ttType="link" ttIcon="far fa-plus" (ttClick)="createNewBook()"></tt-button-goto>
            <div style="flex: 1; overflow: auto">
                <tt-tree-view
                    *ngIf="docArticlesTree"
                    ttRememberId="docarticles.tree"
                    ttOnlyRemember="false"
                    [(ttSelectedId)]="selectedDocArticleKeyno"
                    [ttData]="docArticlesTree"
                    [ttFilter]="filter"
                ></tt-tree-view>
            </div>
        </div>
    </tt-side-drawer>

    <tt-page [hidden]="selectedDocArticleKeyno === ''">
        <tt-page-heading>
            <span [hidden]="drawer.state$ | async" matTooltip="Åpne sidebar" class="fal fa-chevron-square-right tt-drawer-button tt-drawer-button--open" (click)="drawer.open()"></span>
            {{ docArticle.get?.page_heading }}
        </tt-page-heading>
        <div>
            <tt-doc-article style="display: block; max-width: 140rem" #docArticle [params]="{ docarticle_keyno: selectedDocArticleKeyno }" (submit)="onSubmit($event)"></tt-doc-article>
        </div>
    </tt-page>
</tt-side-drawer-container>
<tt-page *ngIf="'mobile' | mediaQuery">
    <tt-page-heading ttModel="p2_m_docarticle" ttTranslate></tt-page-heading>
    <tt-list [ttData]="rootDocArticles"></tt-list>
    <tt-card *ngIf="!!get && get.sub_docarticle_admin === '1'">
        <tt-button-goto ttText="docarticleedit_create_new_book" ttType="link" ttIcon="far fa-plus" (ttClick)="gotoCreateNewBook()"></tt-button-goto>
    </tt-card>
</tt-page>
